import { render, staticRenderFns } from "./CrewReport.vue?vue&type=template&id=637ea92a&scoped=true&"
import script from "./CrewReport.vue?vue&type=script&lang=js&"
export * from "./CrewReport.vue?vue&type=script&lang=js&"
import style0 from "./CrewReport.vue?vue&type=style&index=0&id=637ea92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ea92a",
  null
  
)

export default component.exports